import { render, staticRenderFns } from "./CarouselItem.vue?vue&type=template&id=124ca7ba&scoped=true"
import script from "./CarouselItem.vue?vue&type=script&lang=js"
export * from "./CarouselItem.vue?vue&type=script&lang=js"
import style0 from "./CarouselItem.vue?vue&type=style&index=0&id=124ca7ba&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "124ca7ba",
  null
  
)

export default component.exports